import { useEffect, useRef, useState } from 'react';

/**
 * Подпись клиента пальцем на экране.
 *
 * Это единственное доказательство того, что тару действительно приняли и
 * деньги отдали. Хранится вместе с доставкой и не меняется задним числом.
 */
export function Signature({ onChange }: { onChange: (dataUrl: string | null) => void }) {
  const ref = useRef<HTMLCanvasElement>(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    // Ретина: рисуем в физических пикселях, иначе линия мыльная
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = 150 * dpr;
    canvas.style.height = '150px';
    const ctx = canvas.getContext('2d')!;
    ctx.scale(dpr, dpr);
    ctx.lineWidth = 2.2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#11314a';
  }, []);

  const pos = (e: React.PointerEvent) => {
    const rect = ref.current!.getBoundingClientRect();
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  };

  return (
    <div>
      <canvas
        ref={ref}
        className="sign-pad"
        onPointerDown={(e) => {
          e.currentTarget.setPointerCapture(e.pointerId);
          drawing.current = true;
          const ctx = ref.current!.getContext('2d')!;
          const p = pos(e);
          ctx.beginPath();
          ctx.moveTo(p.x, p.y);
        }}
        onPointerMove={(e) => {
          if (!drawing.current) return;
          const ctx = ref.current!.getContext('2d')!;
          const p = pos(e);
          ctx.lineTo(p.x, p.y);
          ctx.stroke();
          if (empty) setEmpty(false);
        }}
        onPointerUp={() => {
          drawing.current = false;
          onChange(empty ? null : ref.current!.toDataURL('image/png'));
        }}
      />
      <div className="spread" style={{ marginTop: 6 }}>
        <span className="muted" style={{ fontSize: 12 }}>
          {empty ? 'Попросите клиента расписаться' : 'Подпись снята'}
        </span>
        <button
          type="button"
          className="ghost"
          onClick={() => {
            const canvas = ref.current!;
            canvas.getContext('2d')!.clearRect(0, 0, canvas.width, canvas.height);
            setEmpty(true);
            onChange(null);
          }}
        >
          Стереть
        </button>
      </div>
    </div>
  );
}
